export default __webpack_public_path__ + "static/animal-notes-2c0b703ad5640460d0d89907d7962ca3.svg";